<div class="selector-container grid small grid-two">
    <app-selector
        *ngFor="let entry of dataEntries; let isFirst = first; let isLast = last"
        [id]="entry.ID"
        [name]="entry.name | translate"
        [description]="entry.description | translate"
        [showDescription]="true"
        [checked]="entry.checked"
        [imageClassFromFrontEnd]="entry.imageClassFromFrontEnd"
        [isFirst]="isFirst"
        [isLast]="isLast"
        [isSingleItem]="true"
        (selected)="onSelectorClicked($event)"
    ></app-selector>
</div>

<!-- 
<app-lateral-panel id="livinglight-shapes-lateral" class="subtitle-info-lateral secondary"  [extraClasses]="'frameshape grey'">
    <h3 class="primary">{{ "b2c.IDS_LIVINGLIGHTSERIE" | translate }}</h3>
    <div class="serie-container">
        <h4 class="m-b-10 primary">{{ "b2c.IDS_LIVINGLIGHTAIR" | translate }}</h4>
        <div class="secondary-description light-description">
            {{ "b2c.IDS_LIVINGLIGHTAIRDESCRIPTION" | translate }}
        </div>
        <img class="lg-full xs-big" src="../../../assets/img/series/lines/livinglight-air.png" />
    </div>
    <div class="serie-container">
        <h4 class="m-b-10 primary">{{ "b2c.IDS_LIVINGLIGHTSQUARE" | translate }}</h4>
        <div class="secondary-description light-description">
            {{ "b2c.IDS_LIVINGLIGHTSQUAREDESCRIPTION" | translate }}
        </div>
        <img class="lg-full xs-big" src="../../../assets/img/series/lines/livinglight-square.png" />
    </div>
    <div class="serie-container">
        <h4 class="m-b-10 primary">{{ "b2c.IDS_LIVINGLIGHTINTERNATIONAL" | translate }}</h4>
        <div class="secondary-description light-description">
            {{ "b2c.IDS_LIVINGLIGHTINTERNATIONALDESCRIPTION" | translate }}
        </div>
        <img class="lg-full xs-big" src="../../../assets/img/series/lines/livinglight-international.png" />
    </div>
</app-lateral-panel>
 -->